import React from "react";
import { FaMapMarkerAlt, FaEnvelope, FaPhone } from "react-icons/fa";

export default function Contact() {
  return (
    <>
      <br />
      <div className="contact-container">
        <div className="map-fullscreen">
          <iframe
            title="Google Map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3673.173705798938!2d75.86956207517005!3d22.71956807939695!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3962fdc814f736a9%3A0x85ae9c7ae8db3a75!2sIndore%2C%20Madhya%20Pradesh!5e0!3m2!1sen!2sin!4v1719216019097!5m2!1sen!2sin"
            width="100%"
            height="380"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>

        <div className="contact-content">
          <div className="left-card">
            <h2 data-aos="fade-up">Get in Touch</h2>
            <p data-aos="fade-up">
              We would love to hear from you. Reach out to us via the contact
              information below.
            </p>
            <div className="info-block" data-aos="fade-up">
              <div className="info-heading">
                <FaMapMarkerAlt className="card-icon" />
                <h3>Location:</h3>
              </div>
              <p className="card-para">115, SaiRam Plaza, A.B Road, Mangal Nagar Indore, M.P. , 452001</p>
            </div>
            <div className="info-block" data-aos="fade-up">
              <div className="info-heading">
                <FaEnvelope className="card-icon" />
                <h3>Email:</h3>
              </div>
              <p className="card-para">codeonettechnology@gmail.com</p>
            </div>
            <div className="info-block" data-aos="fade-up">
              <div className="info-heading">
                <FaPhone className="card-icon" />
                <h3>Call:</h3>
              </div>
              <p className="card-para no-border">0731-3570575</p>
            </div>
          </div>

          <div className="right-form">
            <form>
              <div className="form-row" data-aos="fade-up">
                <input type="text" placeholder="Your Name" required />
                <input type="email" placeholder="Your Email" required />
              </div>
              <input
                type="text"
                placeholder="Subject"
                required
                data-aos="fade-up"
              />
              <textarea
                rows="5"
                placeholder="Message"
                required
                data-aos="fade-up"
              ></textarea>
              <button type="submit">Send Message</button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
